import React, { useEffect, useState } from "react";

interface Props {
  children: any;
}

export interface IGlobalLoadingContext {
  showGlobalLoading: () => void;
  hideGlobalLoading: () => void;
}

export const GlobalLoadingContext = React.createContext<IGlobalLoadingContext>({
  showGlobalLoading: () => {},
  hideGlobalLoading: () => {},
});

export const GlobalLoadingContextProvider = ({ children }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [isVisible, setVisible] = useState<boolean>(true);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const showGlobalLoading = (): void => {
    setVisible(true);
  };
  const hideGlobalLoading = (): void => {
    setVisible(false);
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------
  const renderLoading = (): React.ReactNode => {
    return (
      <div id={"global-loading"}>
        <i className={"fas fa-spinner fa-spin"} />
      </div>
    );
  };

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
      console.log("[GlobalLoading provider] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
      console.log("[GlobalLoading provider] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <GlobalLoadingContext.Provider
      value={{
        showGlobalLoading,
        hideGlobalLoading,
      }}
    >
      {children}
      {isVisible && renderLoading()}
    </GlobalLoadingContext.Provider>
  );
};
